import { useMemo } from 'react';
import { CorrespondencePartyDto, CorrespondencePartyRoleType } from 'types/correspondence';

export const useCorrespondenceParties = (parties: CorrespondencePartyDto[]) => {
    const { clientParties, senderOrRecipientParties } = useMemo(
        () =>
            parties.reduce(
                (acc, party) => {
                    switch (party.roleTypeCode) {
                        case CorrespondencePartyRoleType.CLIENT:
                            acc.clientParties.push(party);
                            break;
                        case CorrespondencePartyRoleType.RECEIVER:
                        case CorrespondencePartyRoleType.SENDER:
                            acc.senderOrRecipientParties.push(party);
                            break;
                    }
                    return acc;
                },
                {
                    clientParties: [] as CorrespondencePartyDto[],
                    senderOrRecipientParties: [] as CorrespondencePartyDto[],
                }
            ),
        [parties]
    );

    return { clientParties, senderOrRecipientParties };
};
